import { Component } from "react";
//import { useRest } from "react-common";
import { useTranslation } from "react-i18next";

class ErrorBoundary extends Component {
    state = { hasError: false };

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        if (this.props.postData) {
            let errorStr = "";
            if (error?.message && error.message.trim().length > 0) {
                errorStr += error.message + " ";
            }
            if (info?.componentStack && info.componentStack.trim().length > 0) {
                errorStr += info.componentStack;
            } else if (error?.stack && error.stack.trim().length > 0) {
                errorStr += error.stack;
            }
            if (errorStr.length > 0) {
                this.props.postData("ClientError", { error: errorStr });
            }
        }
    }

    render() {
        if (this.state.hasError) {
            if (this.props.hidden) {
                return null;
            }
            return (
                <div
                    style={{
                        height: "100%",
                        width: "100%",
                        padding: 20,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >
                    <div style={{ textAlign: "center" }}>
                        <div style={{ fontSize: 20, fontWeight: "bold" }}>
                            {this.props.t("Sorry, an error occured :(")}
                        </div>
                        <div>
                            {this.props.t(
                                "The error has been sent to the development team, it will be adressed as soon as possible. You can still use the rest of the application."
                            )}
                        </div>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

const ErrorBoundaryWrapper = ({ children, ...props }) => {
    const { postData } = {}; // useRest(); <-- uncomment this (and corresponding import) if you want to send client errors to the server
    const { t } = useTranslation();
    return (
        <ErrorBoundary {...props} postData={postData} t={t}>
            {children}
        </ErrorBoundary>
    );
};

export default ErrorBoundaryWrapper;
